import { render } from "./agent.settings.vue?vue&type=template&id=16f09b4e"
import script from "./agent.settings.vue?vue&type=script&lang=js"
export * from "./agent.settings.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__